"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountStatusBanner = exports.StyledBannerWrapper = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const blocks_1 = require("../../blocks");
exports.StyledBannerWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-StyledBannerWrapper", componentId: "reports-loipp9" }) `
  margin: 24px 24px 0 24px;
`;
/**
 * True displays a green CalloutLink. False returns a red banner
 * @param {boolean} status
 * @returns React.ReactElement
 */
const AccountStatusBanner = ({ status = false }) => {
    return (react_1.default.createElement(blocks_1.CardWithRows.Body, null, status ? (react_1.default.createElement(base_react_components_1.CalloutLink, { iconName: "feedback/thumbs-up", copy: "This account is current", variation: "positive" })) : (react_1.default.createElement(exports.StyledBannerWrapper, null,
        react_1.default.createElement(base_react_components_1.Banner, { type: "error", icon: "feedback/thumbs-down", title: "This account is past due", copy: "It looks like you've got some payments that are beyond terms. Making all your payments within terms will increase your score." })))));
};
exports.AccountStatusBanner = AccountStatusBanner;
exports.default = exports.AccountStatusBanner;
//# sourceMappingURL=index.js.map